import { DOWNLOAD_FILES_QUERY } from './download-files.query';
import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

const CLAIM_CREATE_CLOSING_LETTER_MUTATION = graphql(`
  mutation createClaimClosingLetter($claimUuid: String!) {
    closeClaim(claimUuid: $claimUuid) {
      uuid
      referenceId
      status
    }
  }
`);

export function useCreateClosingLetterMutation() {
  const [claimCreateClosingLetter, { data, loading, error, reset }] =
    useMutation(CLAIM_CREATE_CLOSING_LETTER_MUTATION, {
      refetchQueries: [DOWNLOAD_FILES_QUERY],
      awaitRefetchQueries: true,
    });
  return {
    data,
    claimCreateClosingLetter,
    loading,
    error,
    reset,
  };
}
